import React from 'react';

const ConfirmModal = ({ message, onConfirm, onCancel, isLoading }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        <div className="bg-blue-500 text-white p-2 rounded-t-lg">
          <h3 className="text-lg font-semibold mb-0">Xác nhận</h3>
        </div>
        <div className="modal-body">
          <p className="text-gray-800">{message}</p>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              onClick={() => { console.log('Confirm clicked'); onConfirm(); }}
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              disabled={isLoading}
            >
              {isLoading ? 'Đang xóa...' : 'Xóa'}
            </button>
            <button
              onClick={() => { console.log('Cancel clicked'); onCancel(); }}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Hủy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;